import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a73c891&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a73c891')) {
      api.createRecord('1a73c891', component.options)
    } else {
      api.reload('1a73c891', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a73c891&", function () {
      api.rerender('1a73c891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/social-listening/index.vue"
export default component.exports